import { createFileRoute, redirect } from '@tanstack/react-router'

import { cachedCan } from '@/features/auth/session'
import { bookingFlowSearchSchema } from '@/features/bookings/booking-flow'
// The screen and its state machine share a name and differ only by extension, so the screen is
// asked for by its own: a bare specifier resolves to the `.ts` beside it, which is the pure half.
import { BookingFlow } from '@/features/bookings/booking-flow.tsx'

/**
 * The guided booking, at `/bookings/new`: three questions, one screen each.
 *
 * A page of its own rather than a sheet over whatever opened it, because the step is in the URL —
 * `?step=2` — and that is what makes the phone bar's back arrow step back through the questions
 * instead of leaving the flow.
 *
 * The same address carries the confirmation once a booking has been made (`?booked=<id>`), because
 * it is where the flow ends rather than a screen of the booking's own: the booking's record is one
 * tap on from it, at `/bookings/$bookingId`.
 *
 * `sell` or above, mirroring the API and the drive flow's own routes. A read-only member never
 * sees the way in (`useBookingSheet` hands them no handle at all) and is sent to Today if they
 * reach the address anyway, before the screen renders.
 */
export const Route = createFileRoute('/_app/bookings/new')({
  validateSearch: (search) => bookingFlowSearchSchema.parse(search),
  beforeLoad: ({ context }) => {
    if (!cachedCan(context.queryClient, 'sell')) throw redirect({ to: '/', replace: true })
  },
  component: BookingFlow,
})
